import React from "react";
import { Field } from "formik";
import { makeStyles } from "@material-ui/core";
import formikVideo from "../../articlecontent/VideoFile";
const FieldText = (props) => {
    const useStyles = makeStyles(() => ({ inputItem: { width: "100%" } }));
    const classes = useStyles();
    return (
    <Field
        name={props.name}
        type="file"
        component={formikVideo}
        variant="filled"
        className={classes.inputItem}
        onChange={props.handleChange}
        duration={props.duration}
        inputProps={{ accept: "audio/MP3,audio/*" }}
        edit={props.editopen}
    />
    );
};
export default FieldText;
